import { render } from "./FinishedTestsList.vue?vue&type=template&id=02a347fc"
import script from "./FinishedTestsList.vue?vue&type=script&lang=js"
export * from "./FinishedTestsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__